// AddFoodItems.js
import React, { useMemo, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import AddFoodItemsContainer from './container';
import { useGetCollectionPointsQuery } from 'pages/collectionPoints/services';
import { foodItemType } from 'utils/constant';
import { useGetCategoriesQuery, useAddCategoriesMutation } from 'pages/categories/services';
import FoodCategoriesModal from 'components/Modal/FoodCategories/FoodCategoriesModal';
import { useGetChefsListsQuery, useUploadImageMutation } from 'pages/customers/services';
import { useAddFoodItemMutation, useUpdateFoodItemMutation } from '../services';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetStationsQuery, useAddStationsMutation } from 'pages/stations/services';
import StationsModal from 'components/Modal/Stations/Stations';
import { useAssignChefsMutation, useAvailableChefsQuery } from 'pages/stations/services';
import AddStationWithChefsModal from 'components/Modal/Stations/AddStationWithChefsModal';
import StaffModal from 'components/Modal/StaffModal/StaffModal';
import { useAddStaffsMutation } from 'pages/manageAccounts/services';

const AddFoodItems = () => {
    const { state } = useLocation();
    const editingItem = state?.item;
    const isEdit = Boolean(editingItem);
    const navigate = useNavigate();
    const [saveClick, setSaveClick] = useState(false);
    const [deletedCollectionPoints, setDeletedCP] = useState([]);
    const [deletedGroups, setDeletedGroups] = useState([]);
    const [deletedAddOns, setDeletedAddOns] = useState([]);
    const [stationModalOpen, setStationModalOpen] = useState(false);
    const [categoryModalOpen, setCategoryModalOpen] = useState(false);
    const [staffModalOpen, setStaffModalOpen] = useState(false);
    const [stationModalValues, setStationModalValues] = useState(null);

    const { data: categories = [], isLoading: loadingCats, refetch: refetchCategories } = useGetCategoriesQuery();
    const { data: collectionPoints = [], isLoading: loadingCP } = useGetCollectionPointsQuery();
    const { data: chefs = [], isLoading: loadingChefs } = useGetChefsListsQuery();
    const { data: stationsOptions = [], isLoading: loadingStations } = useGetStationsQuery();
    const { data: availableChefsData, refetch: refetchAvailableChefs } = useAvailableChefsQuery();

    const [addFoodItem, { isLoading: getLoading }] = useAddFoodItemMutation();
    const [addCategories, { isLoading: isCategoryLoading }] = useAddCategoriesMutation();
    const [addStations, { isLoading: isStationLoading }] = useAddStationsMutation();
    const [assignChefs, { isLoading: isAssignChefsLoading }] = useAssignChefsMutation();
    const [updateFoodItem, { isLoading: isUpdateLoading }] = useUpdateFoodItemMutation();
    const [addStaffs, { isLoading: isAddStaffLoading }] = useAddStaffsMutation();
    const [uploadImage] = useUploadImageMutation();

    //   const catOptions = useMemo(() => categories?.data?.records?.map(c => ({ label: c.name, value: c.id })), [categories]);
    const catOptions = useMemo(() =>
        categories?.data?.records
            ?.filter(c => c.active_status == true)
            .map(c => ({ label: c.name, value: c.id })) || [],
        [categories]
    );
    const cpOptions = useMemo(() => collectionPoints?.data?.records?.map(c => ({ label: c.name, value: c.id })), [collectionPoints]);

    // const cpOptions = useMemo(() =>
    // collectionPoints?.data?.records
    //     ?.filter(cp => cp?.active_status == true)
    //     .map(c => ({ label: c.name, value: c.id })) || [],
    // [collectionPoints]
    // );
    const itemOptions = useMemo(() => foodItemType?.map(c => ({ label: c.name, value: c.value })), [foodItemType]);

    const stationOptions = useMemo(() =>
        stationsOptions?.data?.records
            ?.filter(s => s?.status == true)
            .map(s => ({ label: s.name, value: s.id })) || [],
        [stationsOptions]
    );

    // const collectionPointOptions = useMemo(() => collectionPointsOptions?.data?.records?.map(s => ({ label: s.name, value: s.id })) || [], [collectionPointsOptions]);

    //   const chefOptions= useMemo(() => chefs?.data?.records?.map(c => ({ label: c.full_name, value: c.id })), [chefs]);
    // const chefOptions = useMemo(() =>
    //     chefs?.data?.records
    //     ?.filter(cp => cp?.active_status == true)
    //     .map(c => ({ label: c.full_name, value: c.id })) || [],
    // [chefs]
    // );

    // Keep a snapshot of original groups for edit-comparison
    const originalGroups = useMemo(() => editingItem?.groups?.map(g => ({
        name: g.name,
        group_type: g.group_type,
        add_ons: g.add_ons.map(a => ({ name: a.name, price: a.price, notes: a.notes }))
    })) || [], [editingItem]);


    const initialValues = {
        image: null,
        name: '',
        description: '',
        category: null,
        price: '',
        type: null,
        collectionPoints: [],
        primaryChef: null,
        secondaryChef: null,
        addOnGroups: [
            { groupName: '', groupType: null, addOns: [{ name: '', price: '', notes: '' }] }
        ],
        station: null,
        averagePreparationTime: '',
        // only used on edit
        deletedCollectionPoints: [],
        deletedGroups: [],
        deletedAddOns: [],
    };


    const validationSchema = Yup.object({
        image: Yup.mixed().nullable(),
        name: Yup.string().required('Item Name is required'),
        category: Yup.object().nullable().required('Category is required'),
        price: Yup.number().typeError('Must be a number').required('Price is required'),
        type: Yup.object().nullable().required('Type is required'),
        // primaryChef: Yup.object().nullable().required('Primary Chef is required'),
        // secondaryChef optional
        description: Yup.string(),             // now optional
        station: Yup.object().nullable().required('Station is required'),
        averagePreparationTime: Yup.number().typeError('Must be a number').required('Average preparation time is required'),
        collectionPoint: Yup.array(),         // now optional
        addOnGroups: Yup.array(),
        // addOnGroups: Yup.array().of(
        //     Yup.lazy(group => {
        //     const blankGroup =
        //         !group.groupName &&
        //         !group.groupType &&
        //         Array.isArray(group.addOns) &&
        //         group.addOns.every(a => !a.name && !a.price && !a.notes);
        //     if (blankGroup) {
        //         // untouched blank row → skip validation
        //         return Yup.object({
        //         groupName: Yup.mixed().notRequired(),
        //         groupType: Yup.mixed().notRequired(),
        //         addOns: Yup.array().notRequired(),
        //         });
        //     }
        //     // once the user typed anything → full group schema
        //     return Yup.object({
        //         groupName: Yup.string().required('Group name is required'),
        //         groupType: Yup.string().required('Group type is required'),
        //         addOns: Yup.array()
        //         .of(
        //             Yup.lazy(addOn => {
        //             const blankAddOn = !addOn.name && !addOn.price && !addOn.notes;
        //             if (blankAddOn) {
        //                 return Yup.object({
        //                 name: Yup.mixed().notRequired(),
        //                 price: Yup.mixed().notRequired(),
        //                 notes: Yup.mixed().notRequired(),
        //                 });
        //             }
        //             return Yup.object({
        //                 name: Yup.string().required('Add-on name is required'),
        //                 price: Yup.number()
        //                 .typeError('Must be a number')
        //                 .required('Add-on price is required'),
        //                 notes: Yup.string(),
        //             });
        //             })
        //         )
        //         .min(1, 'At least one add-on is required'),
        //     });
        //     })
        // ),
    });

    const formik = useFormik({
        validateOnChange: false,
        validateOnBlur: true,
        enableReinitialize: true,
        initialValues: editingItem ? {
            ...initialValues,
            name: editingItem.name,
            description: editingItem.description || '',
            price: editingItem.price.toString(),
            image: editingItem?.image || null,  // only for upload
            category: catOptions?.find(opt => opt?.value === editingItem?.category.id) || null,
            type: itemOptions?.find(opt => opt?.value === editingItem?.item_type) || null,
            // primaryChef: chefOptions?.find(opt => opt?.value === editingItem?.primary_chef) || null,
            // secondaryChef: chefOptions?.find(opt => opt.value === editingItem?.secondary_chef) || null,
            collectionPoints: cpOptions?.filter(opt => editingItem?.collection_points?.some(cp => cp.id === opt.value)),
            station: stationOptions?.find(opt => editingItem?.station === opt?.value) || null,
            // collectionPoint: collectionPointOptions?.find(opt => editingItem?.station === opt?.value) || null,
            averagePreparationTime: editingItem?.average_preparation_time || '',
            addOnGroups: editingItem.groups.map(g => ({
                id: g.id,
                groupName: g.name,
                groupType: g.group_type,
                addOns: g.add_ons.map(a => ({ id: a.id, name: a.name, price: a.price.toString(), notes: a.notes }))
            })),
        } : initialValues,
        validationSchema: validationSchema,
        // onSubmit: async (values, { resetForm }) => {
        //     let imageFilename = null;
        //     if (values.image && values.image instanceof File) {
        //         const fd = new FormData();
        //         fd.append('file', values.image);
        //         const res = await uploadImage(fd);
        //         imageFilename = res?.data?.data;
        //     }
        //        // filter out blank groups/add-ons
        //     const filteredGroups = values.addOnGroups.reduce((acc, g) => {
        //         const hasGroupInfo = Boolean(g.groupName || g.groupType);
        //         const validAddOns = g.addOns.filter(a => a.name || a.price || a.notes);
        //         if (hasGroupInfo || validAddOns.length > 0) {
        //         acc.push({
        //             name: g.groupName,
        //             group_type: g.groupType?.value ?? g.groupType,
        //             add_ons: validAddOns.map(a => ({ name: a.name, price: a.price ? parseFloat(a.price) : 0, notes: a.notes }))
        //         });
        //         }
        //         return acc;
        //     }, []);

        //     // decide whether to include groups in payload
        //     const shouldSendGroups = !isEdit ? true : JSON.stringify(filteredGroups) !== JSON.stringify(originalGroups);


        //     const payload = {
        //         name: values.name,
        //         // image: imageFilename,
        //         description: values.description,
        //         item_type: values.type.value,
        //         primary_chef: values.primaryChef?.value,
        //         secondary_chef: values?.secondaryChef?.value ? values?.secondaryChef?.value : null,
        //         category_id: values?.category?.value,
        //         collection_points: values?.collectionPoints?.map(c => c.value),
        //         price: parseFloat(values.price),
        //         // groups: values.addOnGroups.map(g => ({
        //         //     name: g.groupName,
        //         //     group_type: g?.groupType?.value,
        //         //     add_ons: g.addOns.map(a => ({ name: a.name, price: a.price ? parseFloat(a.price) : '', notes: a.notes }))
        //         // })),
        //         // groups:[],
        //         ...(shouldSendGroups && { groups: filteredGroups }),
        //         ...(imageFilename && { image: imageFilename }),
        //         ...(isEdit && {
        //             deleted_collection_points: deletedCollectionPoints,
        //             deleted_groups: deletedGroups,
        //             deleted_add_ons: deletedAddOns,
        //         }),
        //     };
        //     console.log(payload,"OPRFAFA")
        //     try {
        //         if (isEdit) await updateFoodItem({ id: editingItem.id, ...payload });
        //         else await addFoodItem(payload);
        //         console.log('Payload:', payload);
        //         resetForm();
        //         if(saveClick){
        //             navigate("/food-items")
        //         }
        //     } catch (err) {
        //         console.error(err);
        //     }
        // }


        onSubmit: async (values, { resetForm }) => {
            let imageFilename = null;
            if (values.image && values.image instanceof File) {
                const fd = new FormData();
                fd.append('file', values.image);
                const res = await uploadImage(fd);
                imageFilename = res?.data?.data;
            }

            const changedGroups = [];

            if (isEdit) {
                for (let g of values.addOnGroups) {
                    const original = originalGroups.find(og => og.name === g.groupName && og.group_type === g.groupType);

                    const isNewGroup = !g.id;
                    if (isNewGroup) {
                        // New group, include entire group
                        changedGroups.push({
                            name: g.groupName,
                            group_type: g.groupType?.value ?? g.groupType,
                            add_ons: g.addOns
                                .filter(a => a.name || a.price || a.notes)
                                .map(a => ({
                                    name: a.name,
                                    price: a.price ? parseFloat(a.price) : 0,
                                    notes: a.notes
                                }))
                        });
                    } else {
                        // Compare to original group
                        const filteredAddOns = g.addOns.filter(a => a.name || a.price || a.notes);
                        const originalAddOns = original?.add_ons || [];

                        const isGroupChanged =
                            g.groupName !== original?.name ||
                            g.groupType !== original?.group_type;

                        const changedAddOns = filteredAddOns.filter(addOn => {
                            const orig = originalAddOns.find(o => o.name === addOn.name);
                            return (
                                !orig ||
                                orig.price !== parseFloat(addOn.price) ||
                                orig.notes !== addOn.notes
                            );
                        });

                        if (isGroupChanged || changedAddOns.length > 0) {
                            changedGroups.push({
                                id: g.id,
                                name: g.groupName,
                                group_type: g.groupType?.value ?? g.groupType,
                                add_ons: changedAddOns.map(a => ({
                                    id: a.id,
                                    name: a.name,
                                    price: a.price ? parseFloat(a.price) : 0,
                                    notes: a.notes
                                }))
                            });
                        }
                    }
                }
            }

            const DEFAULT_FOOD_IMAGE = "1792582106108-121.png";
            let finalImage = DEFAULT_FOOD_IMAGE;

            if (imageFilename) {
                finalImage = imageFilename;
            } else if (values.image && typeof values.image === 'string' && values.image.trim() && !values.image.startsWith('blob:')) {
                finalImage = values.image;
            } else if (isEdit && editingItem?.image) {
                finalImage = editingItem.image;
            } else {
                finalImage = DEFAULT_FOOD_IMAGE;
            }

            const payload = {
                name: values.name,
                description: values.description,
                item_type: values.type.value,
                // primary_chef: values.primaryChef?.value,
                // secondary_chef: values.secondaryChef?.value ?? null,
                category_id: values.category?.value,
                station: values?.station?.value,
                // collectionPoint: values?.collectionPoint?.value,
                average_preparation_time: values.averagePreparationTime ? parseFloat(values.averagePreparationTime) : 0,
                collection_points: values.collectionPoints?.map(c => c.value),
                price: parseFloat(values.price),
                image: finalImage,
                ...(isEdit && {
                    deleted_collection_points: deletedCollectionPoints,
                    deleted_groups: deletedGroups,
                    deleted_add_ons: deletedAddOns,
                    ...(changedGroups.length > 0 && { groups: changedGroups }),
                }),
                ...(!isEdit && {
                    groups: values.addOnGroups
                        .filter(g => g.groupName || g.groupType || g.addOns.some(a => a.name || a.price || a.notes))
                        .map(g => ({
                            name: g.groupName,
                            group_type: g.groupType?.value ?? g.groupType,
                            add_ons: g.addOns
                                .filter(a => a.name || a.price || a.notes)
                                .map(a => ({
                                    name: a.name,
                                    price: parseFloat(a.price) || 0,
                                    notes: a.notes
                                }))
                        }))
                })
            };
            try {
                if (isEdit) await updateFoodItem({ id: editingItem.id, ...payload }).unwrap();
                else await addFoodItem(payload).unwrap();
                resetForm();
                if (saveClick) {
                    navigate("/food-items");
                }
            } catch (err) {
                console.error(err);
            }
        }

    });

    const handleCategorySubmit = async (values, { setSubmitting, setErrors }) => {
        try {
            const res = await addCategories(values).unwrap();
            const refetched = await refetchCategories();
            const newCat = res?.data?.record || res?.data;
            if (newCat?.id) {
                formik.setFieldValue('category', { label: newCat.name || values.name, value: newCat.id });
            } else if (values.name) {
                const matched = refetched?.data?.data?.records?.find(
                    c => c.name?.trim().toLowerCase() === values.name?.trim().toLowerCase()
                );
                if (matched) {
                    formik.setFieldValue('category', { label: matched.name, value: matched.id });
                }
            }
            setCategoryModalOpen(false);
        } catch (error) {
            setErrors(error.data?.errors || {});
        } finally {
            setSubmitting(false);
        }
    };

    const handleStationSubmit = async (values, { setSubmitting, setErrors }) => {
        try {
            const stationData = {
                name: values.name,
                notes: values.notes
            }
            const res = await addStations(stationData).unwrap();

            if (res?.data?.id && values.chefs?.length > 0) {
                await assignChefs({
                    id: res.data.id,
                    body: { chef_ids: values.chefs }
                }).unwrap();
            }

            setStationModalOpen(false);
            setStationModalValues(null);
        } catch (error) {
            setErrors(error.data?.errors || {});
        } finally {
            setSubmitting(false);
        }
    };

    const handleOpenStaffModal = (values) => {
        setStationModalValues(values);
        setStaffModalOpen(true);
    };

    const handleStaffSubmit = async (values, { setSubmitting, setErrors }) => {
        try {
            await addStaffs(values).unwrap();
            await refetchAvailableChefs();
            setStaffModalOpen(false);
        } catch (error) {
            setErrors(error.data?.errors || {});
        } finally {
            setSubmitting(false);
        }
    };

    const chefSelectionOptions = (availableChefsData?.data || []).map(c => ({
        id: c.id,
        name: c.full_name,
    }));

    return (
        <>
            <AddFoodItemsContainer
                formik={formik}
                loading={getLoading || isUpdateLoading}
                catOptions={catOptions}
                stationsOptions={stationOptions}
                // collectionPointsOptions={collectionPointOptions}
                // loadingCollectionPoint={loadingCollectionPoint}
                cpOptions={cpOptions}
                itemOptions={itemOptions}
                // chefOptions={chefOptions}
                loadingCats={loadingCats}
                setSaveClick={setSaveClick}
                saveClick={saveClick}
                deletedHelpers={{ setDeletedCP, setDeletedGroups, setDeletedAddOns }}
                isEdit={isEdit}
                // openStationModal={() => setStationModalOpen(true); refetchAvailableChefs()}
                openStationModal={() => {
                    setStationModalOpen(true);
                    refetchAvailableChefs();
                }}
                openCategoryModal={() => {
                    setCategoryModalOpen(true);
                }}
            />
            <FoodCategoriesModal
                open={categoryModalOpen}
                onClose={() => setCategoryModalOpen(false)}
                onSubmit={handleCategorySubmit}
                loading={isCategoryLoading}
            />
            <AddStationWithChefsModal
                open={stationModalOpen}
                onClose={() => {
                    setStationModalOpen(false);
                    setStationModalValues(null);
                }}
                onSubmit={handleStationSubmit}
                loading={isStationLoading || isAssignChefsLoading}
                chefOptions={chefSelectionOptions}
                initialValues={stationModalValues}
                onAddChef={handleOpenStaffModal}
            />
            <StaffModal
                open={staffModalOpen}
                onClose={() => {
                    setStaffModalOpen(false);
                }}
                onSubmit={handleStaffSubmit}
                loading={isAddStaffLoading}
            />
        </>
    );
};

export default AddFoodItems;